/**
 * @generated SignedSource<<1316d7305e5b0db8c24233e94353f42d>>
 * @relayHash 49d0fa29a904a6ce7e82a1a574467191
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/contemporaryLandingRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contemporaryLandingRootQuery$variables = {
  contemporaryLandingPreviewId: string;
};
export type contemporaryLandingRootQuery$data = {
  readonly viewer: {
    readonly contemporaryLanding: {
      readonly metadata: {
        readonly description: string | null;
        readonly title: string | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingRespLayout_viewer">;
  };
};
export type contemporaryLandingRootQuery = {
  response: contemporaryLandingRootQuery$data;
  variables: contemporaryLandingRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contemporaryLandingPreviewId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "contemporaryLandingPreviewId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ContemporaryLandingMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*:: as any*/),
    (v7/*:: as any*/)
  ],
  "type": "ContemporaryLandingHeader",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cta",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imagePath",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contemporaryLandingRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContemporaryLandingRespLayout_viewer"
          },
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "ContemporaryLanding",
            "kind": "LinkedField",
            "name": "contemporaryLanding",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "contemporaryLandingRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "ContemporaryLanding",
            "kind": "LinkedField",
            "name": "contemporaryLanding",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  (v8/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v2/*:: as any*/),
                      (v12/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "type": "ContemporaryLandingSplashHeader",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v5/*:: as any*/),
                          (v8/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v5/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v10/*:: as any*/),
                                      (v2/*:: as any*/),
                                      (v12/*:: as any*/)
                                    ],
                                    "type": "ContemporaryLandingStyleRowItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "brand",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contemporaryTrackingString",
                                        "storageKey": null
                                      },
                                      (v10/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "itemPk",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "link",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "netPrice",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "retailPrice",
                                        "storageKey": null
                                      },
                                      (v2/*:: as any*/)
                                    ],
                                    "type": "ContemporaryLandingProductRowItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*:: as any*/),
                                      (v3/*:: as any*/),
                                      (v10/*:: as any*/),
                                      (v2/*:: as any*/),
                                      (v12/*:: as any*/)
                                    ],
                                    "type": "ContemporaryLandingFeaturedRowItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bgImagePath",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "location",
                                        "storageKey": null
                                      },
                                      (v13/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v14/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userImagePath",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ContemporaryLandingHeroMakerRowItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*:: as any*/),
                                      (v6/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v14/*:: as any*/)
                                    ],
                                    "type": "ContemporaryLandingMakerRowItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContemporaryLandingCategoryL3",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                          (v12/*:: as any*/),
                                          (v15/*:: as any*/),
                                          (v13/*:: as any*/),
                                          (v10/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v15/*:: as any*/),
                                      (v13/*:: as any*/)
                                    ],
                                    "type": "ContemporaryLandingCategoryL2",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*:: as any*/)
                            ],
                            "type": "ContemporaryLandingRow",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "caption",
                                "storageKey": null
                              },
                              (v9/*:: as any*/),
                              (v10/*:: as any*/),
                              (v12/*:: as any*/)
                            ],
                            "type": "ContemporaryLandingFurnitureTileSection",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*:: as any*/)
                    ],
                    "type": "ContemporaryLandingRow",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*:: as any*/),
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "embedId",
                        "storageKey": null
                      },
                      (v11/*:: as any*/),
                      (v2/*:: as any*/),
                      (v14/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "type": "ContemporaryLandingVideo",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/contemporaryLandingRootQuery",
    "metadata": {},
    "name": "contemporaryLandingRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e846d63abff26818be6e0b9d87c72f09";

export default node;
